import clsx from "clsx";
import React from "react";
import Callout from "web/react/components/callout/callout";
import SVGIcon from "web/react/components/svg-icon/svg-icon";
import TrackedButton from "web/react/components/tracked-button/tracked-button";
import { Button } from "web/react/emo/button";
import analytics from "web/script/analytics/analytics";
import { gettext } from "web/script/modules/django-i18n";
import { AppPreHeaderBarSerializer } from "web/types/serializers";
// eslint-disable-next-line css-modules/no-unused-class
import styles from "./pre-header-bar.module.css";

export interface UserDropdownProps extends ReactComponentProps {
    accountDropdown: AppPreHeaderBarSerializer["account_dropdown"];
    accountText: AppPreHeaderBarSerializer["account_text"];
    accountUrl: AppPreHeaderBarSerializer["account_url"];
    registerUrl: AppPreHeaderBarSerializer["register_url"];
}

function UserDropdown({
    className,
    accountUrl,
    registerUrl,
    accountText,
    accountDropdown,
}: UserDropdownProps): React.ReactElement {
    return (
        <Callout disabled={!accountDropdown} className={clsx(styles.action, className)}>
            <Callout.CTA>
                {accountUrl ? (
                    <>
                        <div
                            className={clsx(
                                styles.actionContainer,
                                styles.authLinks,
                                "hidden-tablet"
                            )}
                        >
                            <Button
                                href={registerUrl as string}
                                size={"sm"}
                                onClick={() => {
                                    analytics.event("navigation", "click", "signup_or_login_link");
                                }}
                                title={
                                    /* "Sign up or log in" */
                                    gettext("header.navigation.sign_in_log_in.cta")
                                }
                            />
                        </div>
                        <div className={clsx(styles.actionContainer, "hidden-desktop")}>
                            <a className="mt5" href={accountUrl}>
                                <SVGIcon className={styles.userIcon} name="user-icon" />
                            </a>
                        </div>
                    </>
                ) : (
                    <>
                        <div className={clsx(styles.actionContainer, "hidden-tablet")}>
                            {accountText} <SVGIcon className={styles.chevronIcon} name="chevron" />
                        </div>
                        <div
                            onClick={() => {
                                analytics.event("top_nav", "clicked", "member_icon");
                            }}
                            className={clsx(styles.actionContainer, "hidden-desktop")}
                        >
                            <SVGIcon className={styles.userIcon} name="user-icon" />
                        </div>
                    </>
                )}
            </Callout.CTA>
            <Callout.Content>
                {accountDropdown && (
                    <>
                        <ul className="app-header-dropdown-list">
                            {accountDropdown.nav_items.map((item) => (
                                <li key={item.url} className={styles.dropdownListItem}>
                                    <TrackedButton
                                        className={styles.dropdownListItemContent}
                                        href={item.url}
                                        eventCategory="nav"
                                        eventAction="clicked"
                                        eventLabel={item.image_url ? "username" : item.text}
                                    >
                                        {item.text}
                                    </TrackedButton>
                                </li>
                            ))}
                        </ul>
                        <a
                            href={accountDropdown.sign_out.url}
                            className={clsx(styles.dropdownListCta, "btn btn--large mt40")}
                        >
                            {accountDropdown.sign_out.text}
                        </a>
                    </>
                )}
            </Callout.Content>
        </Callout>
    );
}

export default UserDropdown;
